import { useNavigate } from 'react-router-dom'
import lockIcon from '../images/lock-icon.svg'
import logoutIcon from '../images/logout-icon.svg'
import '../styles/UserDropdownMenu.css'
import { useCookies } from 'react-cookie'

interface UserDropdownMenuProps {
    handleLogout: () => void
}

export default function UserDropdownMenu({ handleLogout }: UserDropdownMenuProps) {

    const [cookies] = useCookies(['user'])
    const navigate = useNavigate()

    const handleChangePassword = () => {
        navigate(`/change_password`)
    }

    return (
        <div className="UserDropdownMenu">
            <div className="UserDropdownMenu-user">
                <div>
                    <h4>{cookies.user.firstName} {cookies.user.lastName}</h4>
                    <p>{cookies.user.email}</p>
                </div>
            </div>
            <div className="UserDropdownMenu-menu">
            <button className="UserDropdownMenu-menu-item" onClick={handleChangePassword}>
                    <img src={lockIcon}
                        width={18}
                        height={18}
                        alt="logout-icon" />
                    <span>Change password</span>
                </button>
                <button className="UserDropdownMenu-menu-item" onClick={handleLogout}>
                    <img src={logoutIcon}
                        width={18}
                        height={18}
                        alt="logout-icon" />
                    <span>Logout</span>
                </button>
            </div>
        </div>
    )
}